export const environment = {
  production: false,
  host: 'https://app-stage.redepos.com.br',
  loginPort: '6063',
  protocol: 'https://',
  port: '#',
};
